__turbopack_context__.v({
  "root": "NumberFormatter-module__gXxQza__root",
});
